import { Document } from '@contentful/rich-text-types'
import {
  SideBySideResponsive,
  SideBySideResponsiveProps,
} from '@awaze/design-system.components.side-by-side-responsive'
import {
  ResponsiveImage,
  ResponsiveImageProps,
} from 'src/components/ResponsiveImage'
import RichText from 'src/components/RichText/RichText'

export interface SideBySideModuleProps
  extends Omit<Omit<SideBySideResponsiveProps, 'image'>, 'text'> {
  image: ResponsiveImageProps
  textColor?: 'light' | 'dark'
  text?: Document
}

export const SideBySideModule: React.FC<SideBySideModuleProps> = ({
  image,
  textColor,
  text,
  ...props
}) => {
  return (
    <SideBySideResponsive
      {...props}
      text={
        text && (
          <RichText
            content={text}
            textColor={
              textColor === 'light'
                ? 'ColorTextBodyOnDark'
                : 'ColorTextBodyOnWhite'
            }
          />
        )
      }
      image={<ResponsiveImage {...image} />}
    />
  )
}
